import React from "react";
import { CustomChip } from "../CustomChip";

interface IActiveInActiveStatusProps {
  status: string;
  shouldCrop?: boolean;
}

export const StatusRenderer: React.FC<IActiveInActiveStatusProps> = (props) => {
  const status = (props.status || "").toLowerCase();
  const { shouldCrop = false } = props;

  if (status === "active") {
    return <CustomChip color="success" content={"Active"} size="small" />;
  } else if (status === "open") {
    return <CustomChip color="warning" content={"Open"} size="small" />;
  } else if (status === "closed") {
    return <CustomChip color="error" content={"Closed"} size="small" />;
  } else if (status === "re-opened") {
    return <CustomChip color="info" content={"Re-Opened"} size="small" />;
  } else if (status === "inactive") {
    return <CustomChip color="error" content={"Inactive"} size="small" />;
  } else if (status === "new submission") {
    return (
      <CustomChip color="success" content={"New Submission"} size="small" />
    );
  } else if (status === "quote received") {
    return (
      <CustomChip
        color="warning"
        // content={"Quote Received"}
        content={"Pending"}
        // sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "approved") {
    return (
      <CustomChip
        color="success"
        content={shouldCrop ? "AP" : "Approved"}
        size="small"
      />
    );
  } else if (status === "pending") {
    return (
      <CustomChip
        color="warning"
        // content={"Quote Received"}
        content={"Pending"}
        // sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "utility") {
    return (
      <CustomChip
        color="primary"
        content={shouldCrop ? "UT" : "Utility"}
        size="small"
      />
    );
  } else if (status === "marketing") {
    return (
      <CustomChip
        color="secondary"
        content={shouldCrop ? "MK" : "marketing"}
        size="small"
      />
    );
  } else if (status === "authentication") {
    return (
      <CustomChip
        color="default"
        content={shouldCrop ? "AU" : "Authentication"}
        size="small"
      />
    );
  } else if (status === "rejected") {
    return <CustomChip color="error" content={"Rejected"} size="small" />;
  } else if (status === "booked") {
    return <CustomChip color="success" content={"Booked"} size="small" />;
  } else if (status === "cancelled") {
    return <CustomChip color="error" content={"Cancelled"} size="small" />;
  } else if (status === "cancellation") {
    return <CustomChip color="error" content={"Cancellation"} size="small" />;
  } else if (status === "ongoing") {
    return (
      <CustomChip
        color="warning"
        content={"Ongoing"}
        // sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "postponed") {
    return <CustomChip color="primary" content={"Postponed"} size="small" />;
  } else if (status === "prospect") {
    return (
      <CustomChip
        color="warning"
        content={"Prospect"}
        // sx={{ color: "#000 !important" }}
        size="small"
      />
    );
  } else if (status === "visited") {
    return <CustomChip color="success" content={"Visited"} size="small" />;
  } else if (status === "inquiry") {
    return <CustomChip color="warning" content={"Inquiry"} size="small" />;
  } else {
    return <CustomChip color="info" content={status || "--"} size="small" />;
  }
};
